// client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/app';
import posthog from 'posthog-js';

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_API_POSTHOG_HOST || 'https://us.i.posthog.com',
  ui_host: 'https://us.i.posthog.com',
  defaults:'2026-01-30',
  capture_pageview: false,       // handled manually via PostHogPageTracker in app.js
  capture_pageleave: true,       // enables session duration approximation
  persistence: 'localStorage+cookie',
  autocapture: {                 // capture clicks on links, buttons, and role=button elements
    element_allowlist: ['a', 'button', '[role="button"]', '[data-track]'],
  },
  session_recording: {
    maskAllInputs: true,         // masks passwords, emails, and financial data
    maskTextSelector: '[data-sensitive]',
  },
  loaded: (ph) => {
    if (process.env.NODE_ENV === 'development') {
      ph.opt_out_capturing();    // keep dev traffic out of production data
    }
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);